const HeroSection = () => {
  return (
    <section className="relative w-full h-[600px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://public.readdy.ai/ai/img_res/21fc125ac5e862810e9d3b014166c5d7.jpg"
        alt="atco hero"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      <div className="relative z-10 w-full text-center px-6 max-w-3xl mx-auto">
        <p className="text-white/80 text-sm md:text-base tracking-widest mb-4 font-medium">
          つながりが、未来を変える
        </p>
        <h1 className="text-white text-3xl md:text-5xl font-bold leading-tight mb-6">
          atco（アットコ）へようこそ！
        </h1>
        <p className="text-white/85 text-sm md:text-base leading-relaxed mb-4">
          ビジネスパートナー探しでお困りですか？atcoは、貴社のビジネス成長を支援する<br className="hidden md:block" />
          様々なマッチングサービスを提供しています。
        </p>
        <p className="text-white/80 text-sm leading-relaxed mb-8">
          私たちは、お客様のビジネスニーズを深く理解し、最適なパートナーを見つけるお手伝いをいたします。
        </p>
        <a
          href="#contact"
          className="inline-block bg-[#3d6b4f] hover:bg-[#2f5540] text-white text-sm font-semibold px-8 py-3 rounded-md transition-colors cursor-pointer whitespace-nowrap"
        >
          無料相談はこちら
        </a>
      </div>
    </section>
  );
};

export default HeroSection;
